import {useTranslation} from "react-i18next";
import {Table} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DateDisplay from "components/datetime/DateDisplay";

import IconBool from "components/IconBool";
import MQ24GSender from "./models/MQ24GSender";
import {useState} from "react";
import ModalViewPayload from "./ModalViewPayload";
import Queue from "components/queues/Queue";
import ConditionalRender from "components/ConditionalRender";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableSender = ({
    items,
    itemsShow,
    buttonsTB,
    setButtonsTB,
    checkedAll,
    setCheckedAll,
    _TC,
    orderingRef,
}) => {
    const {t: _Tc} = useTranslation("choices");
    const [item, setItem] = useState({...MQ24GSender});
    const [showModalView, setShowModalView] = useState(false);

    function onClickAll(e) {
        let buttons = {...buttonsTB};
        let checkboxes = document.querySelectorAll('#data-list input[type="checkbox"]');
        if (e.target.checked) {
            setCheckedAll(true);
            buttons.send.disabled = false;
            items.current.chosen = itemsShow.map((_, index) => _.uuid);
            checkboxes.forEach((checkbox) => {
                checkbox.checked = true;
            });
        } else {
            setCheckedAll(false);
            buttons.send.disabled = true;
            items.current.chosen = [];
            checkboxes.forEach((checkbox) => {
                checkbox.checked = false;
            });
        }
        setButtonsTB(buttons);
    }

    const onClickCheck = (e) => {
        let idx = parseInt(e.target.dataset.idx);
        let buttons = {...buttonsTB};
        const item_ = items.current.showed[idx];
        if (items.current.chosen.includes(item_.uuid)) {
            items.current.chosen = items.current.chosen.filter((e) => e !== item_.uuid);
            checkedAll && setCheckedAll(false);
        } else {
            items.current.chosen.push(item_.uuid);
        }

        buttons.send.disabled = items.current.chosen.length === 0;

        setCheckedAll(items.current.chosen.length === itemsShow.length);
        setButtonsTB(buttons);
    };

    const onClickView = (item_) => {
        setItem(item_);
        setShowModalView(true);
    };

    return (
        <>
            <Table striped hover responsive>
                <thead>
                    <tr>
                        <th key="-1" style={{width: "32px", verticalAlign: "bottom"}}>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                value="all"
                                onChange={onClickAll}
                            />
                        </th>
                        <th style={{width: "32px"}}></th>
                        <OrderByHeaders orderingRef={orderingRef} />
                        <th>{_TC("label.command")}</th>
                        <th>
                            {_TC("label.mode")}
                            <br />
                            <span className="small">{_TC("label.confirmations")}</span>
                            <br />
                            <span className="small">{_TC("label.date")}</span>
                            <br />
                        </th>

                        <th>{_TC("label.updated")}</th>
                        <th>{_TC("label.status")}</th>
                        <th style={{width: "60px", textAlign: "center"}}>
                            {_TC("label.queue")}
                        </th>
                    </tr>
                </thead>

                <tbody id="data-list">
                    {itemsShow.map((item, index) => (
                        <tr key={index} data-idx={index} onChange={onClickCheck}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxOpModes"
                                    data-idx={index}
                                    value={index}
                                />
                            </td>
                            <td>
                                <ConditionalRender
                                    condition={
                                        item.config.basic || item.config.advanced
                                    }>
                                    <button
                                        type="button"
                                        className="btn btn-link"
                                        onClick={() => onClickView(item)}>
                                        <FontAwesomeIcon icon="eye" />
                                    </button>
                                </ConditionalRender>
                            </td>
                            <td>
                                {item.uuid}
                                <br />
                                {item.model_name}
                            </td>
                            <td>
                                {_Tc("formatTypes." + item.format)} <br />
                            </td>
                            <td>
                                <div>
                                    {_TC("basic") +
                                        ": " +
                                        _TC("command." + item.command.basic[0] || "")}
                                </div>
                                <div>
                                    {_TC("advanced") +
                                        ": " +
                                        _TC(
                                            "command." + item.command.advanced[0] || "",
                                        )}
                                </div>
                            </td>
                            <td>
                                {item.mode}
                                <br />
                                <div>
                                    <span className="me-1">
                                        {_TC("basic") +
                                            ": " +
                                            _TC("confirm.sent.short")}
                                    </span>
                                    <span>{<IconBool value={item.sent.basic} />}</span>
                                    <span className="ms-2 me-1">
                                        {_TC("confirm.confirmed.short")}
                                    </span>
                                    <span>{<IconBool value={item.ack.basic} />}</span>
                                    <br />
                                    <ConditionalRender
                                        condition={item.ack.basic}
                                        fallback="-">
                                        <DateDisplay
                                            date={item.ack_at.basic}
                                            format="DD-MM-YYYY hh:mm"
                                            title={true}
                                        />
                                    </ConditionalRender>
                                </div>
                                <div>
                                    <span className="me-2">
                                        {_TC("advanced") +
                                            ": " +
                                            _TC("confirm.sent.short")}
                                    </span>
                                    <span>
                                        {<IconBool value={item.sent.advanced} />}
                                    </span>
                                    <span className="ms-2 me-1">
                                        {_TC("confirm.confirmed.short")}
                                    </span>
                                    <span>
                                        {<IconBool value={item.ack.advanced} />}
                                    </span>
                                    <br />
                                    <ConditionalRender
                                        condition={item.ack.advanced}
                                        fallback="-">
                                        <DateDisplay
                                            date={item.ack_at.advanced}
                                            format="DD-MM-YYYY hh:mm"
                                            title={true}
                                        />
                                    </ConditionalRender>
                                </div>
                            </td>

                            <td>
                                <DateDisplay
                                    date={item.updated_at}
                                    format="DD-MM-YYYY HH:mm"
                                    title={true}
                                />
                            </td>
                            <td>
                                <div>
                                    {_TC("basic") +
                                        ": " +
                                        _Tc("shippingState." + item.state.basic)}
                                </div>
                                <div>
                                    {_TC("basic") +
                                        ": " +
                                        _Tc("shippingState." + item.state.advanced)}
                                </div>
                            </td>
                            <td className="text-center">
                                <Queue item={item.queue} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <ModalViewPayload
                item={item}
                show={showModalView}
                setShow={setShowModalView}
                _TC={_TC}
            />
        </>
    );
};

export default TableSender;
